import React, {Component} from 'react';
import Stepper from 'react-stepper-horizontal';
import firebase from 'firebase';
import 'moment/locale/es';
import './style.css';
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux';
import { setRuta } from '../../actions'

class RutaItem extends Component {
    constructor(props){
        super(props);
        this.state = {
            ruta: this.props.ruta,
            tiposViajes: this.props.tiposViajes,
            paradas: []
        }
    }

    componentDidMount(){ this.setParadas() }

    setParadas(){
        let { paradas, inicio, destino } = this.state.ruta;
        let tempParadas = [];
        
        tempParadas.push({ title: this.capitalize(this.getFirstWord(inicio.nombre, ',')) });
        if (paradas!==undefined) {
            paradas.map(parada => { tempParadas.push({ title: this.capitalize(this.getFirstWord(parada.placeName, ',')) }) });
        }
        tempParadas.push({ title: this.capitalize(this.getFirstWord(destino.nombre, ',')) });
        this.setState({ paradas: tempParadas });
    }

    getTipoViaje(key){
        let nombre = this.state.tiposViajes.filter(tipoViaje => tipoViaje.value === '' + key);
        return nombre[0]!== undefined?nombre[0].label:'';
    }

    capitalize(s){
        let temp = s.split(" ");
        let res = "";
        for(let i = 0; i < temp.length; i++){
          res = res + " " + temp[i].charAt(0).toUpperCase() + temp[i].substr(1).toLowerCase();
        }
        return res;
    }

    getFirstWord(s, separator){
        let r = s.split(separator);
        return r[0];
    }

    changeState(key){
        firebase.database().ref('Rutas').child(key).once('value').then(snap => {
            let elemeno = snap.val();
            let val = elemeno.estado === 1 ? 0 : 1;
            firebase.database().ref('Rutas').child(key).update({ estado: val });
        });
    }

    updateRuta(ruta){
        this.props.setRuta(ruta);
        this.props.history.push('/newRutes');
    }

    render(){
        let { paradas } = this.state;
        let { ruta } = this.props;
        return(
            <div style={{ borderLeft: `3px solid ${ruta.coloRuta}`, paddingLeft: '3%', fontFamily: 'Lato' }}>
                <div className='row'>
                    <div className='col-2 col-md-2'>
                       <h3 style={{ fontSize: '24', fontWeight: 'bolder' }}>{ruta.nombRuta.toUpperCase()}</h3>
                    </div>
                    <div className='col-6 col-md-6'>
                       <h3 style={{ fontSize: '24', fontWeight: '100' }}>Tipo: {this.getTipoViaje(ruta.tipoViaje)}</h3>
                    </div>
                </div>
                <div style={{ marginTop: '2%', marginLeft: '1%' }} className='row'>
                    <div className='col-4 col-md-4'>
                        <i className='fa fa-map-marker-alt'></i>&nbsp;&nbsp;&nbsp;
                        <span style={{ fontSize: '14', fontWeight: '100' }}>
                            Origen<br/>
                            <span style={{ fontSize: '16', fontWeight: 'bold', marginLeft: '8%' }}>{this.capitalize(this.getFirstWord(ruta.inicio.nombre, ','))}</span>
                        </span>
                    </div>
                    <div className='col-4 col-md-4'>
                        <i className='fa fa-map-marker-alt'></i>&nbsp;&nbsp;&nbsp;
                        <span style={{ fontSize: '14', fontWeight: '100' }}>
                            Destino<br/>
                            <span style={{ fontSize: '16', fontWeight: 'bold', marginLeft: '8%' }}>{this.capitalize(this.getFirstWord(ruta.destino.nombre, ','))}</span>
                        </span>
                    </div>
                </div>
                <div style={{ marginTop: '2%' }} className='row'>
                    <div className='col-6 col-md-6 hideO'>
                        <Stepper
                            circleFontColor='transparent' 
                            defaultColor="#C0C0BC" 
                            activeColor="#C0C0BC" 
                            completeColor="#C0C0BC"
                            defaultTitleColor='#000'
                            size={14}
                            steps={ paradas } />
                    </div>
                    <div className='col-4 col-md-4 text-right'>
                        <div className='row'>
                            <div className='col-12 col-md-12'>
                                <button onClick={() => this.updateRuta(ruta)} type="button" style={{ backgroundColor: '#1DA0FF', paddingLeft: '17%', paddingRight: '17%' }} className="btn btn-info btn-sm">Modificar</button>
                            </div>
                            <div style={{ marginTop: '3%' }} className='col-12 col-md-12'>
                                <button onClick={() => this.changeState(ruta.key)} type="button" style={{ backgroundColor: ruta.estado === 1 ? '#E30000' : '#28a745', paddingLeft: ruta.estado === 1 ? '14%' : '20%', paddingRight: ruta.estado === 1 ? '17%' : '20%' }} className={ ruta.estado === 1 ? "btn btn-danger btn-sm" : "btn btn-success btn-sm"}>{ ruta.estado === 1 ? "Desactivar" : "Activar"}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(null, { setRuta })(withRouter(RutaItem));


// WEBPACK FOOTER //
// ./src/Components/Rutas/RutaItem.js